import { Injectable  } from '@angular/core';

@Injectable ()
export class AccountService {
  account: number;

  setAccount(value) {
    this.account = value;
  }
  getAccount() {
    return this.account;
  }

}
